import './landing.css';
import data from './ContentBoxes'

function BoxLanding({landingPage}) {
    const content = data[landingPage] || [];

    return (
        <div className="d-flex banner-boxes">
            {content.map((item, index) => (
                <div key={index}>
                    {/*<span className="box-tag">{item.tag}</span> */}
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                    <hr />
			<form action={item.buttonHref} method='GET'>
                    <button className="gradient-button">
			<>
                        {item.buttonText} 
                        {item.buttonIcon?<img src={`${process.env.PUBLIC_URL}/${item.buttonIcon}`} alt={item.buttonText} />:<></>}
			</>
                    </button>
			</form>
                </div>
            ))}
        </div>
    );
}

export default BoxLanding;
